export default {
  tagline: 'Платформа для построения digital team',
  heroTag: 'Digital Team AI для координации людей и AI-агентов',
  heroTitle: 'Стройте digital team\nвокруг бизнес-процессов',
  heroSubtitle:
    'Подключите рабочие системы. Найдите процессы, где AI создаёт ценность.',
  heroSubtitle2: 'Создайте управляемых агентов и измерьте результат.',
  heroGraphSource: 'Источник',
  heroGraphTicket: 'Задача',
  heroGraphComments: 'Комментарии',
  heroGraphSprint: 'Спринт',
  heroGraphStatus: 'Статус',
  heroGraphBacklog: 'Бэклог',
  heroGraphBugReport: 'Баг-репорт',
  heroGraphRelease: 'Релиз',
  heroGraphDocs: 'Документы',
  heroGraphSpec: 'Спека',
  heroGraphDecision: 'Решение',
  heroGraphRequirements: 'Требования',
  heroGraphApiDocs: 'API-доки',
  heroGraphChangelog: 'История изменений',
  heroGraphMeetingNotes: 'Заметки встречи',
  heroGraphRunbook: 'Runbook',
  heroGraphContext: 'Контекст',
  heroGraphInterface: 'Интерфейс',
  heroGraphChat: 'Чат',
  heroGraphConversationMemory: 'Память диалога',
  heroGraphQuestion: 'Вопрос',
  heroGraphThread: 'LTM',
  heroGraphOutput: 'Ответ',
  heroGraphAnswer: 'Ответ',
  heroGraphSources: 'Источники',
  heroGraphRoleContext: 'Контекст роли',
  heroGraphAnswerSources: 'Ответ + источники',
  heroGraphJiraContext: 'Контекст Jira',
  heroGraphDocsContext: 'Контекст документов',
  heroGraphLaplaceContext: 'Контекст чата',
  heroGraphSprintScope: 'Scope спринта',
  heroGraphTaskStatus: 'Статус задачи',
  heroGraphBacklogItem: 'Элемент бэклога',
  heroGraphCustomerFeedback: 'Фидбэк клиента',
  heroGraphReleaseWork: 'Работа релиза',
  heroGraphBusinessRequirements: 'Бизнес-требования',
  heroGraphTechnicalDocs: 'Технические документы',
  heroGraphChangeHistory: 'История изменений',
  heroGraphDiscussionNotes: 'Заметки обсуждений',
  heroGraphUserAsks: 'Вопрос пользователя',
  heroGraphPrivateThread: 'LTM',
  heroGraphSourceTrace: 'След источников',
  heroGraphRoleLanguage: 'Язык роли',
  heroGraphConfluencePages: 'Страницы',
  heroGraphConfluenceStrategy: 'Стратегия',
  heroGraphConfluenceDocuments: 'Документы',
  heroGraphGithubPullRequests: 'Пулл-реквесты',
  heroGraphGithubCommits: 'Коммиты',
  heroGraphGithubReleases: 'Релизы',
  heroGraphMailThreads: 'Треды',
  heroGraphMailInbox: 'Входящие',
  heroGraphMailFeedback: 'Фидбэк',
  createWorkspace: 'Попробовать Laplace',
  requestDemo: 'Запросить демо',
  howItWorks: 'Как это работает',
  navTop: 'Laplace',
  navIdea: 'Digital team',
  navSavings: 'Аудит',
  navSolution: 'Модель продукта',
  navResult: 'Измерение',
  navDiscover: 'Аудит',
  navBuild: 'Продукт',
  navMeasure: 'Создание',
  navAudience: 'Для кого',
  navControl: 'Сопровождение',
  navSecurity: 'Безопасность',
  navIntegrations: 'Интеграции',
  navSolutions: 'Решения',
  navPricing: 'Тарифы',
  navResources: 'Материалы',
  login: 'Войти',
  openMenu: 'Открыть меню',

  // Idea section
  ideaEyebrow: 'Продукт',
  ideaTitle: 'Цифровой сотрудник',
  ideaBody:
    'Объедините команды, агентов и системы для совместной работы в одном месте.',
  buildHeadlineProjectManager: 'Project Manager',
  buildHeadlineContentMaker: 'Content Maker',
  buildHeadlineSupport: 'Support',
  buildHeadlineGtmOps: 'GTM Ops',
  buildScreenshotAlt:
    'Экран Laplace с рабочим пространством Dev Team и анализом готовности релиза по данным Jira, Confluence и GitHub',
  teamLabel: 'Команда',
  teamProductOwnerTitle: 'Релизы',
  teamProductOwnerName: 'Release Agent',
  teamProductOwnerBody:
    'Собирает картину по релизу и спринту, объясняет риски и готовит следующий шаг на основе задач, комментариев и документов.',
  teamProductOwnerOutcome: 'Контекст релиза',
  teamProductOwnerSourceTasks: 'Задачи',
  teamProductOwnerSourceComments: 'Комментарии',
  teamProductOwnerSourceDocs: 'Документы',
  teamProductOwnerSourceStatuses: 'Статусы',
  teamProductOwnerPrompt: 'Почему мы выбрали PostgreSQL вместо MongoDB?',
  teamProductOwnerAnswer:
    'Решение зафиксировано в MYT-85: PostgreSQL выбран ради предсказуемых сроков релиза. Влияет на дорожную карту Q3.\n\nИсточник: Jira.',
  teamProductOwnerFeature1Title: 'Определённая роль',
  teamProductOwnerFeature1Body:
    'Агент отвечает за конкретный workflow и ожидаемый результат, а не за абстрактную помощь со всем.',
  teamProductOwnerFeature2Title: 'Разрешённый контекст',
  teamProductOwnerFeature2Body:
    'Использует только подключённые источники и tools текущего workspace.',
  teamProductOwnerFeature3Title: 'Контроль человека',
  teamProductOwnerFeature3Body:
    'Готовит решение и выполняет изменяющие действия только в разрешённых границах.',
  teamAnalystTitle: 'Требования',
  teamAnalystName: 'Requirements Agent',
  teamAnalystBody:
    'Находит требования, связывает их с реализацией и показывает пробелы до того, как они превращаются в возвраты и rework.',
  teamAnalystOutcome: 'Связь требований и реализации',
  teamAnalystSourceRequirements: 'Требования',
  teamAnalystSourceDocs: 'Документы',
  teamAnalystSourceComments: 'Комментарии',
  teamAnalystPrompt: 'Почему мы выбрали PostgreSQL вместо MongoDB?',
  teamAnalystAnswer:
    'Реляционная модель упрощает отчётность и сверку данных. Миграция с MongoDB не потребуется.\n\nИсточник: Confluence.',
  teamAnalystFeature1Title: 'Где описано решение',
  teamAnalystFeature1Body:
    'Находит технические решения в задачах, чатах и документах, даже если неизвестно, где именно их оставили.',
  teamAnalystFeature2Title: 'Проверка требований',
  teamAnalystFeature2Body:
    'Показывает, какие требования уже покрыты реализацией, а где остались расхождения или вопросы.',
  teamAnalystFeature3Title: 'Перевод с технического',
  teamAnalystFeature3Body:
    'Объясняет техническое описание фичи через бизнес-логику, сценарии и критерии готовности.',
  teamEngineersTitle: 'Разработка',
  teamEngineersName: 'Engineering Agent',
  teamEngineersBody:
    'Собирает технический контекст задачи, зависимости и критерии готовности и помогает выполнить следующий разрешённый шаг.',
  teamEngineersOutcome: 'Понятная задача',
  teamEngineersSourceTasks: 'Задачи',
  teamEngineersSourceDescription: 'Описание',
  teamEngineersSourceDocs: 'Документы',
  teamEngineersPrompt: 'Почему мы выбрали PostgreSQL вместо MongoDB?',
  teamEngineersAnswer:
    'Схема и ограничения на стороне БД. Ниже риск рассинхронизации, чем при документной модели.\n\nИсточник: GitHub, Confluence.',
  teamEngineersFeature1Title: 'Где лежат требования',
  teamEngineersFeature1Body:
    'Находит нужную спеку, файл, комментарий или обсуждение, где аналитик описал ожидаемое поведение.',
  teamEngineersFeature2Title: 'Что от меня хотят',
  teamEngineersFeature2Body:
    'Переводит требования на язык реализации: сценарии, ограничения, edge cases и критерии готовности.',
  teamEngineersFeature3Title: 'Сохранить решение',
  teamEngineersFeature3Body:
    'Связывает техническое решение с задачей, чтобы продукт и аналитик потом могли найти и понять его смысл.',
  teamSupportTitle: 'Поддержка',
  teamSupportName: 'Support Agent',
  teamSupportBody:
    'Связывает клиентский фидбэк с задачами, статусами и решениями и готовит последовательный ответ для клиента.',
  teamSupportOutcome: 'Статус по фидбэку',
  teamSupportSourceDocs: 'Документы',
  teamSupportSourceTasks: 'Задачи',
  teamSupportSourceDescription: 'Описание',
  teamSupportPrompt: 'Почему мы выбрали PostgreSQL вместо MongoDB?',
  teamSupportAnswer:
    'Был запрос клиента про сроки миграции и возможное влияние на ответы поддержки. Изменения внутренние, на инфраструктурном уровне, поэтому SLA и сроки ответов клиентам не меняются.\n\nИсточник: Confluence.',
  teamSupportFeature1Title: 'Есть ли задача в Jira',
  teamSupportFeature1Body:
    'Проверяет, была ли уже создана задача по фидбэку клиента, кто её ведёт и в каком она статусе.',
  teamSupportFeature2Title: 'Что уже отвечали',
  teamSupportFeature2Body:
    'Поднимает прошлые ответы, связанные обсуждения и решения, чтобы ответ клиенту был последовательным.',
  teamSupportFeature3Title: 'Brief для команды',
  teamSupportFeature3Body:
    'Собирает фидбэк клиента, связанные задачи и историю обсуждений в понятный запрос для продукта или engineering.',
  teamHowItWorks: 'Как работает',
  teamSources: 'Источники',
  teamOutcome: 'Результат',
  teamVisualRequest: 'Фокус сейчас',
  teamVisualContext: 'Контекст:',
  teamVisualSendLabel: 'Отправить',
  teamVisualTry: 'Попробуй',
  teamVisualTryHint: 'отправь вопрос',
  result: 'Результат',
  unifiedContext: 'Информация есть, но она разбросана и теряется',
  unifiedContextBody:
    'Команда каждый раз заново ищет тикеты, читает обсуждения, проверяет документы и спрашивает людей, которые помнят контекст',

  // Savings section
  savingsEyebrow: 'Аудит',
  savingsTitle:
    'Найдите процесс основанный на фактах, где AI принесёт наибольшую пользу',
  savingsBody:
    'Context Audit превращает общее желание внедрить AI в конкретный план.',
  auditScreenshotAlt:
    'Интерфейс Context Audit с оценкой контекстного долга, графиком динамики и метриками подключённых систем',
  valueItem1Title: 'Сделайте процессы команды измеримыми',
  valueItem1Body:
    'Метрики покажут, насколько стабильно работает каждый процесс и где именно он замедляется, теряет контекст или требует улучшения.',
  valueItem2Title: 'Определите направление AI-интеграций',
  valueItem2Body:
    'Отслеживаемые метрики складываются в отчёт о состоянии процессов и показывают, где внедрение AI даст наибольший эффект.',
  valueItem3Title: 'Получите рекомендации по улучшению процессов',
  valueItem3Body:
    'На основе аудита Laplace показывает, что именно стоит исправить, какие процессы оптимизировать и куда внедрить AI в первую очередь.',
  workspaceVisualProduct: 'Команда разработки',
  workspaceVisualSupport: 'Your support workspace',
  workspaceVisualAnalytics: 'Your analytics workspace',
  workspaceVisualCurrent: 'Текущий воркспейс',
  workspaceVisualAccessScoped: 'Scope ограничен',
  workspaceVisualPlugins: 'Подключённые плагины',
  workspaceVisualJiraScope: 'Задачи, комментарии, статусы и решения команды.',
  workspaceVisualDocsScope: 'Спеки, требования, инструкции и release notes.',
  workspaceVisualPermissions: 'Права пользователя',
  workspaceVisualPermissionsBody:
    'Даже внутри воркспейса пользователь видит только ту информацию, к которой у него есть доступ в исходных системах.',
  workspaceVisualAllowedTask: 'Jira: MYT-12',
  workspaceVisualAllowedDoc: 'Docs: Checkout Scope v2',
  workspaceVisualHiddenChannel: 'Docs: Finance plan',

  // How it works section
  howItWorksTitle: 'Начни работать с digital командой всего в 3 этапа',
  howItWorksBody:
    'От идеи внедрить AI — к работающему процессу меньше чем за час',
  cycleDiscoverTitle: 'Аудит',
  cycleDiscoverBody:
    'Проанализируем ваши процессы и определим, куда именно встроить AI, чтобы получить максимальный эффект.',
  cycleBuildTitle: 'Создание',
  cycleBuildBody:
    'Создавайте сотни цифровых сотрудников с разными ролями и навыками — все в рамках одной подписки.',
  cycleMeasureTitle: 'Измерение',
  cycleMeasureBody:
    'Измеряйте результат внедрения digital-команды в любое время.',

  // Result section
  resultEyebrow: 'Создание',
  resultTitle: 'Сотни цифровых сотрудников по одной подписке.',
  resultBody:
    'Создай цифрового сотрудника и автоматизируй рутинные задачи, чтобы уделять время более ценным вещам в работе',
  resultScreenshotAlt:
    'Экран Laplace с управлением цифровыми сотрудниками, их инструментами, тегами и датами обновления',
  resultAccordionTitle1: 'Роли под ваши процессы',
  resultAccordionBody1:
    'Создавайте цифровых сотрудников для управления проектами, поддержки, контента, продаж и любых внутренних процессов.',
  resultAccordionTitle2:
    'Аудит даст рекомендации по оптимизации ваших процессов',
  resultAccordionBody2:
    'По результатам Context Audit Laplace покажет, какие процессы стоит исправить, оптимизировать и автоматизировать в первую очередь.',
  resultAccordionTitle3: 'Автоматизация рутинных задач',
  resultAccordionBody3:
    'Настраивайте автоматизации по расписанию — цифровые сотрудники выполняют повторяемые операции и передают исключения человеку.',
  question: 'Вопрос',
  questionText: 'Кто отвечает за migration plan и почему мы перенесли релиз?',
  answerLabel: 'Ответ Laplace',
  answerText:
    'За migration plan отвечает Alex. Релиз перенесли, потому что команда зафиксировала риск по схеме данных и решила сначала завершить миграции.',
  answerContext: 'Кто, что, почему, зачем — ответ на любой вопрос по задаче.',
  resultContextItemDiscussions: 'Обсуждения',
  resultContextItemReasons: 'Причины',
  resultContextItemHistory: 'История изменений',
  resultContextItemParticipants: 'Участники',
  // Audiences section
  audiencesEyebrow: 'Два входа',
  audiencesTitle: 'Одна платформа — разные точки старта',
  audiencesBody:
    'Laplace помогает начать AI-цифровизацию с нуля или усилить уже работающую enterprise AI-команду.',
  audienceGrowingEyebrow: 'Для растущих компаний',
  audienceGrowingTitle:
    'Создайте виртуальных сотрудников под процессы вашей компании',
  audienceGrowingBody:
    'Начните с одного виртуального сотрудника, подключите нужные системы и расширяйте digital-команду по мере роста задач.',
  audienceEnterpriseEyebrow: 'Для enterprise AI-команд',
  audienceEnterpriseTitle: 'Аудит, приоритизация и измерение внедрений',
  audienceEnterpriseBody:
    'Найдите следующие возможности, задайте baseline и governance. Реализуйте сценарии в Laplace, собственным стеком или совместно.',

  // End-to-end delivery section
  controlEyebrow: 'Цифровизация под ключ',
  controlTitle: 'Помогаем с цифровизацией ваших процессов от и до',
  controlBody:
    'Наши клиенты всегда в приоритете: подготовим плагины под ваши процессы и учтём любые ваши запросы.',
  controlStep1Title: 'Изучим ваши процессы',
  controlStep1Body:
    'Погрузимся в работу команды, найдём точки цифровизации и вместе определим приоритеты внедрения.',
  controlStep2Title: 'Подготовим решение',
  controlStep2Body:
    'Разработаем нужные плагины, подключим рабочие системы и настроим цифровых сотрудников под ваши процессы.',
  controlStep3Title: 'Запустим и будем развивать',
  controlStep3Body:
    'Поможем с запуском, соберём обратную связь и продолжим улучшать решение вместе с изменениями вашего бизнеса.',
  controlSupportTitle: 'Остаёмся рядом после запуска',
  controlSupportBody:
    'Учитываем новые запросы, дорабатываем интеграции и помогаем масштабировать цифровизацию на следующие процессы.',
  controlDeploymentLabel: 'Работаем в вашем контуре',
  deploymentCloudTitle: 'Cloud',
  deploymentHybridTitle: 'Hybrid',
  deploymentOnPremTitle: 'On-Premises',

  // Demo card
  demoTag: 'Demo Scenario',
  demoTitle: 'Один вопрос. Понятный ответ',
  demoDescription:
    'Laplace даст человеческий ответ из всех знании собранных вашей командой с указанием источника',
  userAsks: 'Пользователь спрашивает',
  demoQuestion: 'Почему запуск для клиента задерживается?',
  laplaceAnswers: 'Laplace отвечает',
  demoAnswer:
    'Запуск задерживается из-за двух блокеров: не закрыта задача LAP-124 по SSO и не согласован чеклист доступа для команды клиента. Ответственный - Alex, следующий шаг - финальное подтверждение security. Источники: Jira, Confluence.',

  // CTA
  ctaTitle: 'Laplace знает все',
  ctaSubtitle: 'Инструмент, который нужен каждому',
  notFoundEyebrow: 'Страница не найдена',
  notFoundTitle: 'Этот маршрут не ведёт ни к одному известному контексту.',
  notFoundShort: 'Упс. Здесь ничего нет.',
  notFoundBody:
    'Возможно, ссылка устарела, адрес был введён вручную с ошибкой или страница уже перемещена. Вернитесь на стартовую страницу или войдите в рабочее пространство.',
  notFoundBackHome: 'На главную',
}
